/*
 * Validare inline pentru formularele de contact (pagini si popup-uri).
 * Inlocuieste popup-ul nativ al browserului cu: border rosu pe camp + text de
 * eroare sub el. Mesaje in romana, pe tipul campului (nume, email, telefon, suma).
 * Se ataseaza automat la orice <form action="/contact...">.
 */
(function () {
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const PHONE_RE = /^[+\d][\d\s().\-]{5,}$/;

  const MSG = {
    name: 'Introduceți numele.',
    emailEmpty: 'Introduceți adresa de email.',
    emailInvalid: 'Adresa de email nu este validă.',
    phoneEmpty: 'Introduceți numărul de telefon.',
    phoneInvalid: 'Numărul de telefon nu este valid.',
    amountEmpty: 'Introduceți suma dorită.',
    required: 'Acest câmp este obligatoriu.',
  };

  function kindOf(el) {
    const name = (el.getAttribute('name') || '').toLowerCase();
    const type = (el.type || '').toLowerCase();
    if (type === 'email' || name === 'contact[email]') return 'email';
    if (type === 'tel') return 'phone';
    if (type === 'number') return 'amount';
    if (el.autocomplete === 'name' || /\bnume\b|\bname\b/.test(name)) return 'name';
    return 'text';
  }

  function amountMessage(el, value) {
    const min = Number(el.getAttribute('min')) || 0;
    const step = Number(el.getAttribute('step')) || 0;
    if (min && value < min) return 'Suma minimă este de ' + min + ' MDL.';
    if (step && value % step !== 0) {
      return 'Suma trebuie să se termine în 0 (de exemplu ' + min + ', ' + (min + step) + ', ' + (min + step * 2) + ').';
    }
    return '';
  }

  function messageFor(el) {
    const value = (el.value || '').trim();
    const kind = kindOf(el);
    const required = el.hasAttribute('required');

    if (value === '') {
      if (!required) return '';
      if (kind === 'email') return MSG.emailEmpty;
      if (kind === 'phone') return MSG.phoneEmpty;
      if (kind === 'name') return MSG.name;
      if (kind === 'amount') return MSG.amountEmpty;
      return MSG.required;
    }

    if (kind === 'email' && !EMAIL_RE.test(value)) return MSG.emailInvalid;
    if (kind === 'phone' && !PHONE_RE.test(value)) return MSG.phoneInvalid;
    if (kind === 'amount') return amountMessage(el, Number(value));
    return '';
  }

  function errorBoxFor(el) {
    const anchor = el.closest('.field') || el;
    /*
      Cutia de eroare sta INAUNTRUL campului, nu dupa el. Ca frate, devenea
      element separat de layout: intr-un container pe coloane primea propria
      celula si impingea campul urmator pe alt rand. Inauntru, ramane mereu
      sub campul la care se refera, indiferent cum e asezat formularul.
    */
    let box = anchor.querySelector(':scope > .contact-inline-error');
    if (!box) {
      box = document.createElement('small');
      box.className = 'contact-inline-error';
      box.hidden = true;
      const span = document.createElement('span');
      span.className = 'form__message errors';
      box.appendChild(span);
      anchor.appendChild(box);
    }
    return box;
  }

  function wireField(el) {
    if (el.dataset.inlineValidation) return;
    el.dataset.inlineValidation = '1';

    const box = errorBoxFor(el);
    const text = box.querySelector('.form__message.errors');

    const render = (force) => {
      const msg = messageFor(el);
      el.setCustomValidity(msg); // blocheaza trimiterea cand e invalid
      if (msg && (force || !box.hidden)) {
        el.classList.add('invalid');
        el.setAttribute('aria-invalid', 'true');
        text.textContent = msg;
        box.hidden = false;
      } else if (!msg) {
        el.classList.remove('invalid');
        el.removeAttribute('aria-invalid');
        box.hidden = true;
      }
    };

    el.addEventListener('input', () => render(false));
    el.addEventListener('blur', () => render(true));
    el.addEventListener('invalid', (event) => {
      event.preventDefault(); // fara bula nativa a browserului
      render(true);
    });
    render(false);
  }

  const SKIP = ['hidden', 'submit', 'button', 'checkbox', 'radio', 'file', 'reset'];

  function wireForm(form) {
    form.querySelectorAll('input, textarea, select').forEach((el) => {
      if (SKIP.indexOf((el.type || '').toLowerCase()) !== -1) return;
      wireField(el);
    });
  }

  function init() {
    document.querySelectorAll('form[action*="/contact"]').forEach(wireForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
